module.exports = __webpack_public_path__ + "7d6a135cf63378645280bb86228e082b.otf";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/Platform-Medium.otf
// module id = 1100
// module chunks = 0